export const partPriceFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
});
export const compactNumberFormatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
});
export function formatPartPrice(price) {
    if (price === undefined)
        return "N/A";
    if (isNaN(price))
        return "N/A";
    return partPriceFormatter.format(price);
}
export function formatPackagingOption(packaging) {
    if (packaging.includes("Tape & Reel")) {
        return "T&R";
    }
    else if (packaging === "Tube-packed") {
        return "Tube";
    }
    else if (packaging === "Cut Tape") {
        return "CT";
    }
    return packaging;
}
export function normalizeLifecycleStatus(lifeCycleStatus) {
    switch (lifeCycleStatus?.trim()) {
        case "Active": {
            return "active";
        }
        case "Obsolete": {
            return "obsolete";
        }
        case "New Product":
        case "New at Mouser":
        case "New Technology": {
            return "new_product";
        }
        case "EOL":
        case "End of Life": {
            return "end_of_life";
        }
        case "Not Recommended for New Designs":
        case "NRND":
        case "Not For New Designs": {
            return "not_recommended_for_new_designs";
        }
        case "Factory Special Order": {
            return "factory_special_order";
        }
        case "Last Time Buy":
        case "LTB": {
            return "last_time_buy";
        }
        case "Verify Status with Factory": {
            return "verify_status_with_factory";
        }
        case "Restricted Availability": {
            return "restricted_availability";
        }
        case "Discontinued at Digi-Key": {
            return "discontinued";
        }
        case "Part Number Change": {
            return "part_number_change";
        }
        case "Custom": {
            return "custom";
        }
        case "Preliminary":
        case "Preliminary Release": {
            return "preliminary_release";
        }
        default: {
            return lifeCycleStatus ?? undefined;
        }
    }
}
export function humanizeLifecycleStatus(lifeCycleStatus) {
    switch (lifeCycleStatus) {
        case "active": {
            return "Active";
        }
        case "obsolete": {
            return "Obsolete";
        }
        case "new_product": {
            return "New Product";
        }
        case "end_of_life": {
            return "End of Life";
        }
        case "not_recommended_for_new_designs": {
            return "Not Recommended for New Designs";
        }
        case "factory_special_order": {
            return "Factory Special Order";
        }
        case "last_time_buy": {
            return "Last Time Buy";
        }
        case "verify_status_with_factory": {
            return "Verify Status with Factory";
        }
        case "restricted_availability": {
            return "Restricted Availability";
        }
        case "discontinued": {
            return "Discontinued";
        }
        case "part_number_change": {
            return "Part Number Change";
        }
        case "custom": {
            return "Custom";
        }
        case "preliminary_release": {
            return "Preliminary Release";
        }
        default: {
            return lifeCycleStatus;
        }
    }
}
//# sourceMappingURL=formatters.js.map